/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stripe_Unavailable_ReloadInputs */

const en_stripe_unavailable_reload = /** @type {(inputs: Stripe_Unavailable_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reload page`)
};

const es_stripe_unavailable_reload = /** @type {(inputs: Stripe_Unavailable_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recargar página`)
};

/**
* | output |
* | --- |
* | "Reload page" |
*
* @param {Stripe_Unavailable_ReloadInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const stripe_unavailable_reload = /** @type {((inputs?: Stripe_Unavailable_ReloadInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stripe_Unavailable_ReloadInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_stripe_unavailable_reload(inputs)
	return en_stripe_unavailable_reload(inputs)
});